// Module
var code = "<input type=\"search\" ng-model=\"search\" ng-keypress=\"onKeypress($event)\" placeholder=\"Search for listings using keywords or address\"/><button id=\"search-page__search-button\" class=\"btn btn-inverse\"><i aria-hidden=\"true\" class=\"fa fa-search\"></i></button> ";
// Exports
var _module_exports =code;;
var path = '/codebuild/output/src3495824897/src/frontend/js/directives/public/textSearch.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;